//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.Subdivision.js";
import "../no/Builder.js";
import "../Features/Features.Subdivision.SelectCageObjectData.js";
import "../no/ugmath.js";
import "../no/Features.js";
let d=[[[1,"FacesToSplit",0,"Features.Subdivision.SelectCageObjectData",0],[0,"Number",1,0],[1,"ReferenceEdge",0,"Features.Subdivision.SelectCageObjectData",0],[0,"Type",1,0]],[[["location","object"],"AddSplitPoint",{},2,0],[[],"ClearSplitPoints",{},0,0],[["splitLineIndex","positions"],"UpdateSplitPositions",{},2,0]],[]];
SPLM.Features.Subdivision.SubdivisionSplitFaceBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.Subdivision.SubdivisionSplitFaceBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.Subdivision.SubdivisionSplitFaceBuilder.Types = Object.freeze({
    "Uniform" : "Uniform", "ThroughLines" : "ThroughLines"});

export default SPLM;